exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-10-wrapper[data-v-ada19394]{width:235px;padding-bottom:10px}.listing-img[data-v-ada19394]{width:24px;height:24px;border-radius:50%}", ""]);

// exports
